import { render, staticRenderFns } from "./InformationPanel.vue?vue&type=template&id=b40f2b36&"
import script from "./InformationPanel.vue?vue&type=script&lang=js&"
export * from "./InformationPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports